import _ from "lodash";
import {translateName} from "../../../../utils/i18n";

export const entity = {
    name: "AuditRisk",
    facets: ["codeName"],
    fields: [
        {path: "active", type: "boolean", default: true},
        {
            path: "translatedFullName",
            $f: function(object, context, callback) {
                const language = _.get(context, "language.id")
                return callback(null, `${object.code} : ${translateName(object.name, language)}`)
            }
        }
    ],
    filters: [
        {
            name: "activeRisks",
            isDefault: false,
            query: () => ({active: true})
        },
        {
            name: "byActiveStatus",
            path: 'activeStatus',
            object: 'ActiveStatus',
            display: "name",
            translate: true,
            client: true,
            default: { id: 'active', name: 'active' },
            isDefault: false,
            query: function(context) {
                const status = _.get(context, 'data.activeStatus')
                return !!status?.id ?
                    status?.id === 'inactive' ? {active: false} : {active: true}
                    : {}
            }
        }
    ]
}

export const module_ = {
    object: "AuditRisk",
    tKey: "mTitle_auditRisk",
    category: {
        path: "audit",
        icon: "clipboardCheck"
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    filters: ["byActiveStatus"],
    viewMap: {
        dt: [
            "code",
            {path: "name", translateName: true}
        ],
        form: [
            {path: "code", required: true},
            {path: "name", type: "textarea", required: true},
            {path: "active", type: "booleanToggle", default: true}
        ]
    }
}